const KEY = 'locale'
const DEFAULT_LOCALE = 'es'

const saveLocale = locale => {
  try {
    localStorage.setItem(KEY, locale)
    return true
  } catch (err) {
    console.warn('Error saving config', err)
    return false
  }
}

const loadLocale = () => {
  try {
    const locale = localStorage.getItem(KEY)
    return locale || DEFAULT_LOCALE
  } catch (err) {
    console.warn('Error loading config', err)
    return DEFAULT_LOCALE
  }
}

export { saveLocale, loadLocale }
